import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaBilliardShapeOptions } from '../upp-konva-options';

/** Billiard table shape. */
export class UppKonvaBilliardShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'BILLIARD' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaBilliardShapeOptions) {
        super({ ...opts, data: {} });
    }
}
